/**
 * abilityVfxDesperatePower — Ryze R Desperate Power runic ring aura (SP-12).
 */
export function buildDesperatePower(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.5 * (spec.scale || 1.55);
  const deep = mat(THREE, spec.color || 0x312e81, 0.88);
  const glow = mat(THREE, 0x6366f1, 0.9);
  const bright = mat(THREE, 0xa5b4fc, 0.92);
  addRings(THREE, group, s, deep, glow, bright);
  addGlyphs(THREE, group, s, bright);
  addWisps(THREE, group, s, glow);
  addCore(THREE, group, s, bright);
  group.userData = { shape: 'ring', spin: true };
  return group;
}

function addRings(THREE, group, s, deep, glow, bright) {
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.75, s * 1.1, 28).rotateX(-Math.PI / 2),
    deep
  );
  outer.position.y = 0.05;
  group.add(outer);
  const mid = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.5, s * 0.72, 24).rotateX(-Math.PI / 2),
    glow
  );
  mid.position.y = 0.35 * s;
  group.add(mid);
  const inner = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.28, s * 0.42, 20).rotateX(-Math.PI / 2),
    bright
  );
  inner.position.y = 0.55 * s;
  group.add(inner);
}

function addGlyphs(THREE, group, s, bright) {
  for (let i = 0; i < 4; i += 1) {
    const glyph = new THREE.Mesh(new THREE.BoxGeometry(0.1 * s, 0.22 * s, 0.05 * s), bright);
    const a = (Math.PI / 2) * i;
    glyph.position.set(Math.cos(a) * s * 0.82, 0.5 * s, Math.sin(a) * s * 0.82);
    group.add(glyph);
  }
}

function addWisps(THREE, group, s, glow) {
  for (let i = 0; i < 4; i += 1) {
    const a = (Math.PI / 2) * i + Math.PI / 4;
    const wisp = new THREE.Mesh(
      new THREE.ConeGeometry(0.08 * s, 0.55 * s, 5),
      glow
    );
    wisp.position.set(Math.cos(a) * s * 0.6, 0.28 * s, Math.sin(a) * s * 0.6);
    group.add(wisp);
  }
}

function addCore(THREE, group, s, bright) {
  const core = new THREE.Mesh(new THREE.SphereGeometry(s * 0.18, 8, 8), bright);
  core.position.y = 0.45 * s;
  group.add(core);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
